import React, { useState } from 'react'
import Template from './Template'
import DraftCalendar from './DraftCalendar'
import { useOutletContext } from 'react-router-dom';

export default function EventManager() {

    const [tab, setTab] = useState(1)

    const outletContext = useOutletContext();
    const navOpen = outletContext?.navOpen ?? true; // Default to true if context not available

  return (
    <div className={navOpen ? 'outlet' : 'outlet-expanded'} style={{padding: '2rem'}}>
        <div className='tabs'>
            <button className={tab===1 ? 'tab-active': ''} onClick={() => setTab(1)}>
                Template
            </button>
            <button className={tab===2 ? 'tab-active': ''} onClick={() => setTab(2)}>
                Drafts
            </button>
        </div>

        {tab === 1 &&
            <Template />
        }

        {tab === 2 &&
            <DraftCalendar />
        }

        
    </div>
  )
}
